import { z } from "zod";

export const passwordSchema = z
  .string()
  .min(8, "Password must have at least 8 characters")
  .max(100, "Password should be no longer than 100 characters");
